import styled from 'styled-components';
import { fontSizes, fontWeights, lineHeights } from '../../defaultTheme';
const H2 = styled.h2 `
  font-size: ${fontSizes.xxLarge}px;
  line-height: ${lineHeights.root};
  font-weight: ${({ weight }) => fontWeights[weight || 'regular']};
  margin: 0;

  &:focus {
    outline: none;
  }
`;
export default H2;
//# sourceMappingURL=H2.js.map